module.exports = __webpack_public_path__ + "img/index-qysl12.c6f48c98.png";